<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.72103 6.79219H6.86353M3.58603 5.01094V9.4082C3.58603 9.78611 3.73616 10.1486 4.0034 10.4158L9.52529 15.9377C10.0817 16.4942 10.9841 16.4942 11.5405 15.9377L15.9378 11.5404C16.4942 10.984 16.4942 10.0817 15.9378 9.52519L10.4159 4.00331C10.1487 3.73607 9.7862 3.58594 9.40829 3.58594H5.01103C4.22402 3.58594 3.58603 4.22393 3.58603 5.01094ZM7.14853 6.79219C7.14853 6.98894 6.98903 7.14844 6.79228 7.14844C6.59553 7.14844 6.43603 6.98894 6.43603 6.79219C6.43603 6.59544 6.59553 6.43594 6.79228 6.43594C6.98903 6.43594 7.14853 6.59544 7.14853 6.79219Z"
      :stroke="stroke"
      :fill="fill"
      stroke-width="1.5"
      stroke-linecap="square"
    />
  </svg>
</template>

<script>
export default {
  name: 'TagIcon',
  props: {
    fill: {
      type: String,
      default: 'none'
    },
    stroke: {
      type: String,
      default: '#303546'
    },
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped lang="css">
</style>
